import { useEffect } from "react";

import useResponse from "../../hooks/useResponse";
import { handlehideContextualLoader, handleShowContextualLoader } from "../../utils/contextualLoaderTrigger";

export default function Stepper() {
  const { handleStep } = useResponse();

  useEffect(() => {
    const executeStep = async () => {
      try {
        handleShowContextualLoader();
        await handleStep();
      } catch (error) {
        console.error("Error while handling step:", error);
      } finally {
        console.log("Step execution completed");
        handlehideContextualLoader();
      }
    };

    executeStep();
  }, [handleStep]);

  return null;
}
